// extracted by mini-css-extract-plugin
export default {"page":"styles_page__dNU+Y","text":"styles_text__Yx0Ub","error":"styles_error__qTqb+","number":"styles_number__SAPNM","button":"styles_button__lR5zF"};